import { spacer20 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
export var Body = styled.div.withConfig({
  displayName: "Body",
  componentId: "sc-19u46fy-0"
})(["padding-inline-start:", ";padding-inline-end:", ";overflow:auto;"], spacer20, spacer20);